import { render, staticRenderFns } from "./AuthInviteAdminRegisterPracticeForm.vue?vue&type=template&id=6ec6ec61&scoped=true"
import script from "./AuthInviteAdminRegisterPracticeForm.vue?vue&type=script&lang=js"
export * from "./AuthInviteAdminRegisterPracticeForm.vue?vue&type=script&lang=js"
import style0 from "./AuthInviteAdminRegisterPracticeForm.vue?vue&type=style&index=0&id=6ec6ec61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6ec61",
  null
  
)

export default component.exports